__turbopack_context__.v({
  "border": "hero-module-scss-module__siJq4q__border",
  "hero": "hero-module-scss-module__siJq4q__hero",
  "heroLarge": "hero-module-scss-module__siJq4q__heroLarge",
  "heroMedium": "hero-module-scss-module__siJq4q__heroMedium",
  "heroSmall": "hero-module-scss-module__siJq4q__heroSmall",
});
